/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { ReactionButtonContainer_settings$ref } from "./ReactionButtonContainer_settings.graphql";
import { UserTagsContainer_settings$ref } from "./UserTagsContainer_settings.graphql";
declare const _FeaturedCommentContainer_settings$ref: unique symbol;
export type FeaturedCommentContainer_settings$ref = typeof _FeaturedCommentContainer_settings$ref;
export type FeaturedCommentContainer_settings = {
    readonly " $fragmentRefs": ReactionButtonContainer_settings$ref & UserTagsContainer_settings$ref;
    readonly " $refType": FeaturedCommentContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FeaturedCommentContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ReactionButtonContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings",
            "args": null
        }
    ]
} as any);
(node as any).hash = '901f09edb60a99fbe1ee1ccad0e1427e';
export default node;
